import { isEmail, isMobilePhone, isURL, length } from 'class-validator';
import { activePhoneRegex, activeEmailRegex, fullNameRegex, httpRegex } from '@hilma/netina2all';

import { createRules } from '../../functions';

export const associationRules = createRules({
	associationName: { name: i18n => i18n.assoRl.assoName, greaterThan: 2, smallerThan: 45, required: true },
	contactName: { name: i18n => i18n.assoRl.contactName, regex: fullNameRegex, greaterThan: 2, smallerThan: 45, required: true },
	phone: {
		activeRegex: activePhoneRegex, required: true, classValidator: (value: string) => isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10), name: i18n => i18n.assoRl.phone
	},
	confirmPhone: {
		activeRegex: activePhoneRegex, required: true, classValidator: (value: string) => isMobilePhone(value, 'he-IL') && (new RegExp(/^\d+/)).test(value) && length(value, 10, 10), name: i18n => i18n.assoRl.phone
	},
	email: { activeRegex: activeEmailRegex, required: true, classValidator: (value: string) => isEmail(value) },
	website: { name: i18n => i18n.am.web, required: true, classValidator: (value: string) => isURL(value), regex: httpRegex, activeRegex: httpRegex, activeRegexErr: i18n => i18n.errText.website },
	haveSection46: { required: true },
	haveSignedContract: { required: true },
	haveDrivers: { required: true }
});